// const { sandbox } = require("./sandbox");
let config = {
  production: {
    studio: {
      bucket: "https://studio-creatives-prod-586151543060-euwest2.s3-eu-west-2.amazonaws.com/public",
      indexFile: "index.min.html",
    },
  },
  staging: {
    studio: {
      bucket: "https://studio-creatives-stag-586151543060-euwest2.s3-eu-west-2.amazonaws.com/public",
      indexFile: "index.min.html",
    },
  },
  development: {
    studio: {
      bucket: "https://studio-creatives-dev.s3-eu-west-2.amazonaws.com/public", //sandbox?.studio?.bucket || "https://studio-creatives-dev.s3-eu-west-2.amazonaws.com/public",
      indexFile: "index.min.html",
    },
  },
};
export default {
  ...config,
};
